import cx from 'classnames';
import React from 'react';
/**
 * TooltipWrapper
 * - Provides an optional container that determines where the tooltip aligns to
 */
export const TooltipWrapper = ({ children, className, inline, wrapperRef, ...rest }) => (React.createElement("div", { className: cx('tds-tooltip-wrapper', { 'tds-tooltip-wrapper--inline': inline }, className), ref: wrapperRef, ...rest }, children));
